window.$ = $;

const numberOfPostsToAdd = $('#default-max-posts').val();

function handleHashtagButtonClick(e) {
    const $target = $(e.target),
        hashtag = $target.data('name');

    if (e.target !== this) {
        $target.parent().click();
        return;
    }
    filterCategories(hashtag);
    selectCategory(hashtag);
}

function filterCategories(hashtag) {
    const $otherArticle = $('.other-article');
    let counter = 0;

    if (hashtag === $('#all-category-name').val()) {
        return restoreDefaultCategories($otherArticle);
    }
    $otherArticle.each((i, article) => {
        const $article = $(article);

        if (counter >= numberOfPostsToAdd) {
            return false;
        }
        if ($article.data('category') === hashtag) {
            $article.fadeIn();
            counter++;
        } else {
            $article.fadeOut();
        }
    });
}

function restoreDefaultCategories($otherArticle) {
    let counter = 0;

    $otherArticle.each((i, article) => {
        if (counter >= numberOfPostsToAdd) {
            return false;
        }
        $(article).fadeIn();
        counter++;
    });
}

function selectCategory(hashtag) {
    $('.hashtag').each((i, hashtagObj) => {
        const $hashtagObj = $(hashtagObj);

        if ($hashtagObj.data('name') === hashtag) {
            $hashtagObj.addClass('hashtag-active');
        } else {
            $hashtagObj.removeClass('hashtag-active');
        }
    });
}

function handleShowMoreButtonClick(e) {
    e.preventDefault();
    showMore();
}

function getSelectedCategory() {
    return $('.hashtag-active').first().data('name');
}

function showMore() {
    const hashtag = getSelectedCategory(),
        allHashtag = $('#all-category-name').val();
    let counter = 0;

    $('.other-article').each((i, article) => {
        const $article = $(article);

        if (counter >= numberOfPostsToAdd) {
            return false;
        }
        if (($article.is(':hidden')) &&
            ((hashtag === allHashtag) || $article.data('category') === hashtag)) {
            $article.fadeIn();
            counter++;
        }
    });
}

function toggleFilters() {
    $('.filters').slideToggle();
}

$('.hashtag').on('click', handleHashtagButtonClick);
$('.show-more').on('click', handleShowMoreButtonClick);
$('.toggle-filters').on('click', toggleFilters);
